import { h } from 'preact'
import { useEffect, useState, useMemo } from 'preact/hooks';
import { createPortal } from 'preact/compat';
// import { Pagination } from '../pagination.js'
import { filterRegistrars } from './helper.js';

const maxPerPage = 10;

const continentTitles = {
  af: 'Africa',
  an: 'Antarctica',
  as: 'Asia',
  eu: 'Europe',
  na: 'North America',
  oc: 'Oceania',
  sa: 'South America',
  us: 'USA',
};

export function SearchResultRegistrar({data, domain}) {
  const getSearchParam = name => {
    const params = new URLSearchParams(window.location.search);
    return params.get(name);
  };

  const [ currentPageNo, updatePageNo ] = useState(1);
  const [ filteredData, updateFilteredData ] = useState([]);
  const [ haveMore, updateStatus ] = useState(false);
  const [ filter, updateFilter ] = useState(getSearchParam('filter') ||'');
  const [ sortValue, setSortValue ] = useState(getSearchParam('sort') || 'new_price_amount');
  const [ isAsc, setIsAscValue ] = useState(getSearchParam('asc') || true);

  const registrars = filterRegistrars(data, filter, sortValue, isAsc);

  const continents = useMemo(() => 
    data?.reduce(
      (cons, registrar) => registrar.continent
        ? [
            ...cons, 
            ...registrar.continent
              .split(' ')
              .map(continent => continent.trim().toLowerCase())
              .filter(continent => !cons.includes(continent))
          ].sort()
        :  cons
      ,
      []
    ),
    [ data ]);

  useEffect(() => {
    const firstBatch = (currentPageNo - 1) * maxPerPage;
    updateFilteredData(registrars?.slice(0, firstBatch + maxPerPage));
  }, [ registrars, currentPageNo ]);

  useEffect(() => {
    updateStatus((currentPageNo * maxPerPage) < registrars.length )
  }, [ filteredData ])

  const nextPage = (e) => {
    e.preventDefault();
    updatePageNo(page => page + 1 )
  }

  const setSearchParam = (name, value) => {
    const params = new URLSearchParams(window.location.search);
    if (value && value !== '') {
      params.set(name, value);
    } else {
      params.delete(name);
    }
    params.sort();
    history.replaceState(null, null, `?${params}`);
  };

  const filterByArea = (e) => {
    const val = e.target.value;
    updateFilter(val);
    setSearchParam('filter', val);
  }

  const changeSortValue = (field, isAsc = false) => {
    setSortValue(field);
    setIsAscValue(isAsc);
    setSearchParam('asc', isAsc);
    setSearchParam('sort', field);
  }

  const domainMessage = document.getElementById('domainMessage');

  function sortingClass(field) {
    return field === sortValue ? isAsc === true ? 'desc' : 'asc' : 'asc'
  }

  return (
    <section class="mx-4 sm:mx-6 lg:mx-14">
      {createPortal(<h1 class="text-3xl text-center py-5" >Greate choice! <p class="text-green inline">{domain}</p> is avaliable.</h1>, domainMessage)}
        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            <label for="hs-radio-group" class="flex cursor-pointer justify-between bg-brandColor4 rounded-full py-5 md:py-4 px-4 items-center ">
              <span class="text-white mr-2 text-basic">Worldwide</span>
              <input type="radio" name="hs-radio-group" class="shrink-0 w-[15px] h-[15px] md:w-[22px] md:h-[22px] border-gray2 rounded-full text-brandColor " id="hs-radio-group" value="" checked={'' === filter} onChange={filterByArea}/>
            </label>
          {
            continents?.map((c, i) => (
              <label for={`hs-radio-group-${i}`} class="flex cursor-pointer justify-between bg-brandColor4 rounded-full py-5 md:py-4 px-4 items-center ">
                <span class="text-white mr-2 text-basic">{continentTitles[c]}</span>
                <input type="radio" name="hs-radio-group" class="shrink-0 w-[15px] h-[15px] md:w-[22px] md:h-[22px] border-gray2 rounded-full text-brandColor " id={`hs-radio-group-${i}`} value={c} checked={c === filter} onChange={filterByArea}/>
              </label>
            ))
          }
        </div>
        <div class="table border-collapse table-auto w-full divide-y divide-gray-200 mt-4 ">
          <div class="table-header-group sticky top-[56px] sm:top-[77px] md:top-[105px] bg-brandColor2">
            <div class="table-row">
              <div class="table-cell px-4 md:px-6 py-3 text-left text-xs font-medium text-default "></div>
              <div class={`table-cell py-3 text-center text-base font-medium text-default ${sortingClass('new_price_amount')}`} 
                onClick={() => changeSortValue('new_price_amount', sortingClass('new_price_amount') === "asc")}>
                  <div class="flex justify-between items-center px-4 cursor-pointer">
                    <div>Register</div>
                    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11.7607 2.09343C12.0798 1.77435 12.0798 1.25701 11.7607 0.937928C11.4416 0.618845 10.9243 0.618846 10.6052 0.937929L6.21428 5.32883L1.82338 0.937928C1.5043 0.618845 0.986965 0.618845 0.667883 0.937928C0.348801 1.25701 0.348802 1.77435 0.667884 2.09343L5.63654 7.06208C5.95562 7.38116 6.47295 7.38116 6.79204 7.06208L11.7607 2.09343Z" fill="#FD5A1F"/>
                    </svg>
                  </div>
                </div>
              <div class={`md:table-cell py-3 hidden text-center  font-medium text-default ${sortingClass('renew_price_amount')}`} 
                onClick={() => changeSortValue('renew_price_amount', sortingClass('renew_price_amount')=== "asc")}>
                  <div class="flex justify-between items-center px-4 cursor-pointer">
                    <div>Renew</div>
                    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11.7607 2.09343C12.0798 1.77435 12.0798 1.25701 11.7607 0.937928C11.4416 0.618845 10.9243 0.618846 10.6052 0.937929L6.21428 5.32883L1.82338 0.937928C1.5043 0.618845 0.986965 0.618845 0.667883 0.937928C0.348801 1.25701 0.348802 1.77435 0.667884 2.09343L5.63654 7.06208C5.95562 7.38116 6.47295 7.38116 6.79204 7.06208L11.7607 2.09343Z" fill="#FD5A1F"/>
                    </svg>
                  </div>
              </div>
              <div class={`md:table-cell  py-3 hidden text-center font-medium text-default ${sortingClass('transfer_price_amount')}`} 
                onClick={() => changeSortValue('transfer_price_amount', sortingClass('transfer_price_amount') === "asc")}>
                  <div class="flex justify-between items-center px-4 cursor-pointer">
                    <div>Transfer</div>
                    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11.7607 2.09343C12.0798 1.77435 12.0798 1.25701 11.7607 0.937928C11.4416 0.618845 10.9243 0.618846 10.6052 0.937929L6.21428 5.32883L1.82338 0.937928C1.5043 0.618845 0.986965 0.618845 0.667883 0.937928C0.348801 1.25701 0.348802 1.77435 0.667884 2.09343L5.63654 7.06208C5.95562 7.38116 6.47295 7.38116 6.79204 7.06208L11.7607 2.09343Z" fill="#FD5A1F"/>
                    </svg>
                  </div>
              </div>
              <div class="md:table-cell px-4 md:px-6 py-3 hidden text-right font-medium text-default "></div>
            </div>
          </div>
          <div class="table-row-group divide-y divide-gray-200 ">
            {
              filteredData.map((registrar) => {
                const url = registrar.orderurl && registrar.orderurl !== '' ? registrar.orderurl.replace(/<string>/g, domain) : `https://${registrar.link}`;
                return (
                  <div class="table-row">
                    <div class="table-cell px-4 py-3 whitespace-nowrap text-lg w-1/2 md:w-auto">
                      <div class="justify-evenly items-center flex flex-col lg:flex-row">
                        <img src={registrar.logourl} alt={registrar.registrar_name} 
                          class="w-28 h-28 object-contain "/>
                        <div class="whitespace-pre-line w-full text-center lg:ml-3">{registrar.registrar_name}</div>
                      </div>
                    </div>
                    <div class="md:table-cell px-4 py-3 hidden whitespace-nowrap text-left align-middle font-bold">
                      ${registrar.price_register}
                    </div>
                    <div class="md:table-cell px-4 py-3 hidden whitespace-nowrap text-left align-middle font-bold">
                      ${registrar.price_renew}
                    </div>
                    <div class="md:table-cell px-4 py-3 hidden whitespace-nowrap text-left align-middle font-bold">
                      ${registrar.price_transfer}
                    </div>
                    <div class="table-cell px-4 py-3 whitespace-nowrap text-center align-bottom md:align-middle">
                      <div class="flex gap-5 flex-col">
                        <div class="font-bold md:hidden text-[16px]">
                          ${registrar.price_register}
                        </div>
                        <div>
                          <a class="bg-brandColor inline-flex items-center pl-7 pr-3 py-4 text-white rounded-[100px]" href={url} target="_blank" >
                            Register Now
                            <svg width="18" height="18" viewBox="0 0 18 18"  fill="#fff" class="ml-7" xmlns="http://www.w3.org/2000/svg">
                              <path d="M2.16971 0.372264C1.67336 -0.124087 0.868614 -0.124088 0.372263 0.372263C-0.124088 0.868614 -0.124087 1.67336 0.372264 2.16971L7.20255 9L0.372263 15.8303C-0.124088 16.3266 -0.124088 17.1314 0.372263 17.6277C0.868614 18.1241 1.67336 18.1241 2.16971 17.6277L9.89872 9.89872C10.3951 9.40237 10.3951 8.59763 9.89872 8.10128L2.16971 0.372264Z" />
                            </svg>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
        <div class="flex justify-center mt-4">
        {
          // <Pagination currentPageNo={currentPageNo} onChangePage={updatePageNo} totalNoOfPage={Math.ceil(data.length / maxPerPage)}/>
          haveMore && <a class="bg-brandColor inline-flex items-center pl-7 pr-3 py-4 text-white rounded-[100px]" onClick={nextPage} target="_blank" >
            Load more
            <svg width="18" height="18" viewBox="0 0 18 18"  fill="#fff" class="ml-7 mt-3 mr-3 rotate-90" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.16971 0.372264C1.67336 -0.124087 0.868614 -0.124088 0.372263 0.372263C-0.124088 0.868614 -0.124087 1.67336 0.372264 2.16971L7.20255 9L0.372263 15.8303C-0.124088 16.3266 -0.124088 17.1314 0.372263 17.6277C0.868614 18.1241 1.67336 18.1241 2.16971 17.6277L9.89872 9.89872C10.3951 9.40237 10.3951 8.59763 9.89872 8.10128L2.16971 0.372264Z" />
            </svg>
          </a>
        }
      </div>
    </section>
  )
}